<template>
  <div class="container">
    <div class="row" v-if="!add_item">
      <div class="form-group col-md-12 m-0">
        <div class="col-12 alert alert-info mb-0">
          <legend>ADEUDOS DEL DECLARANTE, CÓNYUGE, CONCUBINA O CONCUBINARIO Y/O DEPENDIENTES ECONÓMICOS (SITUACIÓN ACTUAL)<br> </legend>
        </div>
      </div>
      <div class="form-group col-md-12">
        <div class="col-12 alert alert-info mb-0"> En el caso de tarjeta de crédito no llenar monto_original original del adeudo y plazo del adeudo. </div>
      </div>
      <div class="form-group col-md-4">
        <label class="control-label"> ¿ Tiene adeudos / pasivos? <b-button class="btn-popover" v-b-popover.hover.top="info.adeudos"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <div class="col-12 alert alert-info"> Todos los datos de los Adeudos / Pasivos a nombre de la pareja o dependientes económicos y/o terceros o que sean en copropiedad con el declarante no serán públicos. </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label class="control-label">Titular del adeudo <b-button class="btn-popover" v-b-popover.hover.top="info.titular"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable class="select-default" placeholder="Seleccione una opción" name="titular" v-validate="'required'" v-model="form_item.titular">
              <el-option v-for="option in titular_adeudo" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('titular')}}</small>
          </div>
          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">Tercero <b-button class="btn-popover" v-b-popover.hover.top="info.tercero"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="tercero" class="d-inline-block" v-validate="'required'" v-model="form_item.tercero" label="1">Persona física</p-radio>
            <p-radio name="tercero" class="d-inline-block" v-validate="'required'" v-model="form_item.tercero" label="2">Persona moral</p-radio>
            <br><small class="text-danger">{{ errors.first('tercero')}}</small>
          </div>
          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">Nombre del tercero o terceros <b-button class="btn-popover" v-b-popover.hover.top="info.nombre"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre" v-validate="'required'" v-model="form_item.nombre_tercero" placeholder="Nombre o razón social">
            <small class="text-danger">{{ errors.first('nombre')}}</small>
          </div>
          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">RFC <b-button class="btn-popover" v-b-popover.hover.top="info.rfc"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc" v-validate="'required|uppercase|max:13'" v-model="form_item.rfc_tercero" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Tipo de adeudo <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_adeudo"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable class="select-default" name="tipo_adeudo" v-validate="'required'" placeholder="Seleccione una opción" v-model="form_item.cat_tipo_adeudo_id">
              <el-option v-for="option in tipos_adeudos" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('tipo_adeudo')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_adeudo == 6">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="especifique" v-validate="'required'" v-model="form_item.especifique" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('especifique')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Número de identificador deuda o contrato <b-button class="btn-popover" v-b-popover.hover.top="info.identificador_deuda"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" name="identificador_deuda" type="text" v-validate="'required'" v-model="form_item.identificador_deuda" placeholder="Número de identificador_deuda o contrato">
            <small class="text-danger">{{ errors.first('identificador_deuda') }} </small>
          </div>

          <div class="form-group col-6">
            <label class="control-label">Fecha de adquisición del adeudo/pasivo <b-button class="btn-popover" v-b-popover.hover.top="info.fecha"><i class="far fa-question-circle"></i></b-button></label>
            <!--  <input class="form-control" type="date" name="fecha" v-validate="'required'" v-model="form_item.fecha" placeholder="fecha"> -->
            <el-date-picker name="fecha" v-validate="'required'" v-model="form_item.fecha_adeudo" type="date" placeholder="Seleccione fecha" value-format="dd-MM-yyyy" format="dd-MM-yyyy"></el-date-picker>
            <small class="text-danger">{{ errors.first('fecha')}}</small>
          </div>

          <div class="form-group col-6 ">
            <label class="control-label">Monto original del adeudo/pasivo <b-button class="btn-popover" v-b-popover.hover.top="info.monto_original+' '+info.cat_tipo_moneda_id"><i class="far fa-question-circle"></i></b-button></label>
            <div class="customCurrency">
              <b-input-group size="sm" :prepend="getSigno">
                <b-form-input name="monto_original" v-validate="getVMonto()" type="number" min="0" class="text-right" v-model="form_item.monto_original" placeholder="0" @keyup.native="isNumber" @blur.native="isNumber" />
                <!-- @keyup.native="isNumber($event,form_item.valor_adquisicion)" -->
                <b-dropdown right split :text="getCodigoMoneda" v-model="form_item.cat_tipo_moneda_id">
                  <b-dropdown-item v-for="option in monedas" :key="option.codigo" :value="option.codigo" @click="form_item.cat_tipo_moneda_id = option.id">{{option.moneda}}</b-dropdown-item>
                </b-dropdown>
              </b-input-group>
            </div>
            <small class="text-danger">{{ errors.first('monto_original')}}</small>
          </div>
          <!-- <div class="form-group col-6">
            <label class="control-label">Monto original del adeudo/pasivo. <b-button class="btn-popover" v-b-popover.hover.top="info.monto_original"><i class="far fa-question-circle"></i></b-button></label>
            <el-input-number name="monto_original" v-validate="'required|decimal:0'" v-model="form_item.monto_original" controls-position="right" :min="0"></el-input-number>
            <small class="text-danger">{{ errors.first('monto_original')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Tipo de moneda <b-button class="btn-popover" v-b-popover.hover.top="info.cat_tipo_moneda_id"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" name="cat_tipo_moneda_id" v-validate="'required'" filterable placeholder="Seleccione una opción" v-model="form_item.cat_tipo_moneda_id">
              <el-option v-for="option in monedas" class="select-default" :value="option.id" :label="option.moneda" :key="option.moneda">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('cat_tipo_moneda_id') }}</small>
          </div> -->
          <div class="form-group col-6">
            <label class="control-label">Saldo insoluto <b-button class="btn-popover" v-b-popover.hover.top="info.saldo_pendiente"><i class="far fa-question-circle"></i></b-button></label>
            <div class="customCurrency">
              <b-input-group size="sm" :prepend="getSigno">
                <b-form-input name="saldo_pendiente" v-validate="'required|min:1'" type="number" min="0" class="text-right" v-model="form_item.saldo_pendiente" placeholder="0" @keyup.native="isNumber" @blur.native="isNumber" />
                <!-- @keyup.native="isNumber($event,form_item.valor_adquisicion)" -->
                <b-dropdown right split :text="getCodigoMoneda" v-model="form_item.saldo_cat_tipo_moneda_id">
                  <b-dropdown-item v-for="option in monedas" :key="option.codigo" :value="option.codigo" @click="form_item.saldo_cat_tipo_moneda_id = option.id">{{option.moneda}}</b-dropdown-item>
                </b-dropdown>
              </b-input-group>
            </div>
            <!-- <el-input-number name="saldo_pendiente" v-validate="'required|decimal:0'" v-model="form_item.saldo_pendiente" controls-position="right" :min="0"></el-input-number>
             -->
            <!-- <input class="form-control" type="text" name="saldo_pendiente" v-validate="'required'" v-model="form_item.saldo_pendiente" placeholder="Monto mensual"> -->
            <small class="text-danger">{{ errors.first('saldo_pendiente')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Otorgante del crédito <b-button class="btn-popover" v-b-popover.hover.top="info.otorgante"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="otorgante" class="d-inline-block" v-validate="'required'" v-model="form_item.otorgante" label="1">Persona física</p-radio>
            <p-radio name="otorgante" class="d-inline-block" v-validate="'required'" v-model="form_item.otorgante" label="2">Persona moral</p-radio>
            <br><small class="text-danger">{{ errors.first('otorgante')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Nombre, Institución o razón social (si aplica) <b-button class="btn-popover" v-b-popover.hover.top="info.nombre_acreedor"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre_acreedor" v-validate="'required'" v-model="form_item.nombre_acreedor" placeholder="Nombre o razón social">
            <small class="text-danger">{{ errors.first('nombre_acreedor')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC <b-button class="btn-popover" v-b-popover.hover.top="info.rfc_acreedor"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc_acreedor" v-validate="'required|max:13'" v-model="form_item.rfc_acreedor" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc_acreedor')}}</small>
          </div>
          <legend>¿Dónde se localiza el adeudo? <b-button class="btn-popover" v-b-popover.hover.top="info.lugar"><i class="far fa-question-circle"></i></b-button>
          </legend>
          <div class="form-group  col-6">
            <label class="control-label"> País </label>
            <el-select clearable name="pais" v-validate="'required'" class="select-default" filterable placeholder="País" v-model="form_item.domicilio_acreedor_cat_pais_id">
              <el-option v-for="option in paises" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('pais') }}</small>
          </div>
          <div class="form-group col-12">
            <label class="control-label">Aclaraciones / Observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.observaciones" placeholder="Aclaraciones / Observaciones">
          </div>
        </div>

        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="!edit_item ">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
            </v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.titular="{ item }">
                <div>{{filterCatalog(item.titular,titular_adeudo)}}</div>
              </template>
              <template v-slot:item.cat_tipo_adeudo_id="{ item }">
                <div>{{filterCatalog(item.cat_tipo_adeudo_id,tipos_adeudos)}}</div>
              </template>
              <template v-slot:item.monto_original="{ item }">
                <div>${{item.monto_original | currency}}</div>
              </template>
              <template v-slot:item.saldo_pendiente="{ item }">
                <div>${{item.saldo_pendiente | currency}}</div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  import Domicilio from "../Domicilio.vue";
  import {
    mapFields
  } from "vee-validate";
  import {
    error
  } from 'util';
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
      Domicilio
    },
    props: ["data"],

    data() {
      return {
        ip_id: 1,
        add_item: false,
        edit_item: false,
        bandera: '0',
        search: '',
        form_item: {},
        table_list: [],
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Titular del adeudo',
          value: 'titular',
          align: 'center',
        }, {
          text: 'Tipo de adeudo',
          value: 'cat_tipo_adeudo_id',
          align: 'center',
        }, {
          text: 'Número de identificador_deuda o contrato',
          value: 'identificador_deuda',
          align: 'center',
        }, {
          text: 'Fecha de adquisición',
          value: 'fecha_adeudo',
          align: 'center',
        }, {
          text: 'Monto original ',
          value: 'monto_original',
          align: 'center',
        }, {
          text: 'Saldo insoluto',
          value: 'saldo_pendiente',
          align: 'center',

        }, {
          text: 'Nombre, Institución o razón social ',
          value: 'nombre_acreedor',
          align: 'center',
        }, ],
        info: {
          adeudos: 'Para la declaración de inicio reportar la situación de adeudos/pasivos a la fecha de ingreso al empleo, cargo o comisión. Para la declaración de modificación reportar la situación de adeudos/pasivos del año inmediato anterior. Para la declaración de conclusión reportar la situación de adeudos/pasivos a la fecha de conclusión del empleo, cargo o comisión. El Declarante reportará la información sobre cualquier tipo de deuda y por cada una de ellas.',
          titular: 'Seleccionar alguna de las opciones del catálogo desplegable. En caso de señalar codeudor deberá indicar el nombre del tercero o terceros.',
          tercero: 'En caso de ser codeudor con un tercero, seleccionar si es persona física o persona moral.',
          nombre: 'En caso de señalar codeudor, escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
          rfc: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
          tipo_adeudo: 'Seleccionar cualquiera de las siguientes opciones: crédito hipotecario, crédito automotriz, crédito personal, tarjeta de crédito bancaria, tarjeta de crédito departamental y préstamo personal, otros. Se entenderá por crédito personal, aquel obtenido ante una institución de crédito o bancaria. Se entenderá por préstamo personal, aquel obtenido a través de un familiar, amigo y/o conocido del Declarante.',
          identificador_deuda: 'Señalar el número de contrato, identificador_deuda o cualquier dato que permita su identificación, en caso de préstamo personal se indicará no aplica.',
          fecha: ' Indicar la fecha en que adquirió el adeudo.',
          monto_original: 'Es necesario capturar cantidades sin comas, sin puntos, sin centavos y sin ceros a la izquierda. El monto_original a reportar será el inicial al adeudo.',
          cat_tipo_moneda_id: 'Seleccionar la moneda relativa al adeudo.',
          saldo_pendiente: 'Es necesario capturar cantidades sin comas, sin puntos, sin centavos y sin ceros a la izquierda.',
          otorgante: 'Seleccionar si es persona física o persona moral.',
          nombre_acreedor: 'Señalar el nombre de la institución donde contrajo la deuda.',
          rfc_acreedor: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
          lugar: 'Indicar si se encuentra en México o en el extranjero, debiendo señalar el país donde se localiza.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },

      };
    },
    computed: {
      terceros() {
        if (this.form_item) {
          if (this.form_item.titular) {
            var arr = [3, 4, 5, 8, 10, 13, 15, 18, 19, 24, 25];
            return arr.includes(this.form_item.titular);
          }
        }
        return false;
      },
      getSigno() {
        var signo = "$";
        var val = this.form_item.cat_tipo_moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo;
          }
        });
        return signo;
      },
      getCodigoMoneda() {
        var codigo = "MXN";
        var val = this.form_item.cat_tipo_moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            codigo = item.codigo;
          }
        });
        return codigo;
      },
    },
    watch: {

    },
    methods: {
      getVMonto() {
        if (this.form_item.cat_tipo_adeudo_id == 5)
          return ''
        else
          return 'required|min:1'
      },


      showItem() {
        this.add_item = true;
        if (!this.form_item.domicilio_acreedor_cat_pais_id) {
          //El id Mexico es 150
          this.form_item.domicilio_acreedor_cat_pais_id = 150;
        }
        this.$validator.resume();
      },
      cancelEdit() {
        this.add_item = false;
        this.form_item = {};
        this.edit_item = false;
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("deudas", this.form_item).then(response => {
                this.StepOk("Guardado");
                //if (this.edit_item === undefined || this.edit_item === null) {
                if (!this.edit_item) {
                  this.table_list.unshift({
                    ...response.data.response
                  });
                } else {
                  let index = this.table_list.map(u => {
                    return u.id;
                  }).indexOf(response.data.response.id);
                  this.table_list.splice(index, 1, response.data.response);
                }
                this.cancelEdit();
              }, error => {
                this.StepError(error);
              });
            }
          } else {
            this.StepW("Hay campos sin completar");
            this.scrolling();
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = true;
        this.form_item = {
          ...item
        };
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("deudas/" + item.id).then(response => {
              let index = this.table_list.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.table_list.splice(index, 1);
              this.StepOk('Registro eliminado');
            }, error => {
              this.Err(error);
            });
          });
        }
      },



    },
    created() {
      this.ip_id = this.getKey('uid');
      //this.getLocalidades(97250);
      this.$http.get("deudas/" + this.ip_id).then(response => {
        this.table_list = response.data.response;
        if (this.table_list) {
          if (this.table_list.length > 0) {
            this.bandera = '1';
          }
        }
      }, error => {
        this.Err(error);
      });
    },
    mounted() {
      this.checkCatalogs();
      this.form_item.domicilio_acreedor_cat_pais_id = 150;
    },
  };

</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Pasivos/Deudas.vue